import { useSelector } from "@/core/redux/store";
import { useTranslation } from "react-i18next";

const ProductCategoryReadonly = () => {
  const { t } = useTranslation();
  const { specification } = useSelector(
    (state) => state.specification.specification
  );

  const categoryNames = specification?.categoryNames;
  const categoryList = categoryNames?.categoryList ?? [];
  const sortedCategoryList = [...categoryList]?.sort(
    (a, b) => b.score - a.score
  );
  const selectedBaseCategory = categoryNames?.selectedCategory;

  const selectedCategory =
    selectedBaseCategory ?? sortedCategoryList?.[0]?.category;

  const unspecifiedCategory = !categoryNames || categoryList.length == 0;

  return (
    <div className="flex flex-col justify-center px-1.5 h-[49px] cursor-default">
      {/* Ana kategori gösterimi */}
      <div
        className={`relative border-r border-l border-zinc-200 flex items-center gap-1 justify-between w-full px-[12px] py-[6px] bg-white h-full ${
          unspecifiedCategory ? "opacity-60" : ""
        }`}
      >
        <span
          className={`w-full capitalize font-600 truncate text-[13px] ${
            unspecifiedCategory ? "text-muted-foreground" : ""
          }`}
        >
          {unspecifiedCategory ? t("product-category") : selectedCategory}
        </span>
      </div>
    </div>
  );
};

export default ProductCategoryReadonly;
